import { Button } from "primereact/button";
import { useNavigate } from "react-router";

const ComingSoon = () => {
    const navigate = useNavigate();
    return (
        <div className="coming-soon">
            <div>
                <div>
                    <h2>Coming soon</h2>
                </div>
                <div className="coming-soon">
                    <Button link onClick={() => { navigate('/'); }}>Return to Home</Button>
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;